import prepareTranslate from '@/helpers/dictionary';
import PropTypes from 'prop-types';
import SectionView from '@/components/SectionView';
import Modal from '@/components/DetailsModal';
import { formatDateToString } from '@/helpers/string';
import DownloadFile from '@/components/DownloadFile';

function ViewAgentExpense(props) {
  const {
    expense,
    open,
    close,
    opened,
  } = props;

  const t = prepareTranslate();

  // TODO: move to agentview functions
  const detailsLines = [
    {
      title: t('components.editExpenses.type'),
      value: expense?.type,
    },
    {
      title: t('components.editExpenses.sum'),
      value: expense?.value,
    },
    {
      title: t('components.editExpenses.comments'),
      value: expense?.comments,
    },
    expense?.isRecurring === true
      ? {
        title: t('components.editExpenses.isRecurringActive'),
        value: expense?.isRecurringActive ? 'כן' : 'לא',
      }
      : {
        title: t('components.editExpenses.isPaid'),
        value: expense?.isPaid ? 'כן' : 'לא',
      },
    expense?.isRecurring === false && {
      title: t('components.editExpenses.payDate'),
      value: formatDateToString(expense?.payDate),
    },
    expense?.isRecurring === false && {
      title: t('components.editExpenses.date'),
      value: formatDateToString(expense?.date),
    },
  ].filter(Boolean);

  return (
        <Modal
        open={open}
        close={close}
        opened = {opened}
        label={t('components.viewAgentExpenses.modalTitle')}
        >
      <SectionView
        lines={detailsLines}
      />
      {expense?.files?.map((file, index) => (
        <DownloadFile key={index} file={file} />
      ))}
    </Modal>

  );
}

ViewAgentExpense.propTypes = {
  expense: PropTypes.object,
  open: PropTypes.func,
  close: PropTypes.func,
  opened: PropTypes.bool,

};

export default ViewAgentExpense;
